import PropTypes from 'prop-types';

const PageBuild = ({ sections, template, pageSlug = '', className = '' }) => {
  const Page = sections.map(({ component }, index) => {
    if (!component) {
      console.warn(
        `Page builder - A component field is required on all content types to pass the data appropriately, page: ${pageSlug}`,
      );
      return false;
    }
    const componentType = component.toLowerCase();
    const Component = template[componentType];
    if (Component) {
      return (
        <Component
          key={sections[index].id}
          data={sections[index]}
          pageSlug={pageSlug}
          className={className}
        />
      );
    }
    console.warn(
      `Page builder - Didn't find a component to match the ${component} value, page: ${pageSlug}`,
    );
    return false;
  });
  return <>{Page}</>;
};

PageBuild.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  template: PropTypes.shape().isRequired,
  pageSlug: PropTypes.string,
  className: PropTypes.string,
};

export default PageBuild;
